
import { createSlice } from '@reduxjs/toolkit'
import { CountryList,countryCode,CityList } from '../api/CountryList'

const initialState = {
    country:[],
    countryCode:[],
    cityList:[],
    loading:false,
}
 
export const countrySlice = createSlice({
  name: 'countrySlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(CountryList.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(CountryList.fulfilled , (state, action) => {
        state.country=action.payload.data.data;
        state.loading = false;
      })
      builder.addCase(CountryList.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(countryCode.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(countryCode.fulfilled , (state, action) => {
        state.countryCode=action.payload;

        state.loading = false;
      })
      builder.addCase(countryCode.rejected, (state, action) => {
        state.loading = false;
      
      })


      builder.addCase(CityList.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(CityList.fulfilled , (state, action) => {
        state.cityList=action.payload;
     
        state.loading = false;
      })
      builder.addCase(CityList.rejected, (state, action) => {
        state.loading = false;
      
      })
     
  },

 

})



export default countrySlice.reducer